import React from 'react';
import { motion } from 'framer-motion';
interface CyberButtonProps {
  children: ReactNode;
  onClick?: () => void;
  variant?: 'primary' | 'secondary' | 'outline';
  className?: string;
  type?: 'button' | 'submit' | 'reset';
}
export function CyberButton({
  children,
  onClick,
  variant = 'primary',
  className = '',
  type = 'button'
}: CyberButtonProps) {
  const baseStyles = 'relative px-8 py-3 font-orbitron font-bold uppercase tracking-wider transition-all duration-300 clip-path-polygon';
  const variants = {
    primary: 'bg-cyber-purple text-white hover:bg-cyber-pink hover:shadow-neon-pink border border-transparent',
    secondary: 'bg-cyber-cyan text-cyber-black hover:bg-white hover:shadow-neon-cyan border border-transparent',
    outline: 'bg-transparent text-cyber-green border border-cyber-green hover:bg-cyber-green/10 hover:shadow-neon-green'
  };
  return <motion.button type={type} onClick={onClick} className={`${baseStyles} ${variants[variant]} ${className}`} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} style={{
    clipPath: 'polygon(10% 0, 100% 0, 100% 70%, 90% 100%, 0 100%, 0 30%)'
  }} data-id="element-165">
      {children}
    </motion.button>;
}